// Components
import { RootState } from '../index';

const getBillingReportData = (state: RootState) => state.billingReportDataSlice.billing_report;

export { getBillingReportData };
